<template>
  <div id="gnssRawfileChartModal">
    <div
      class="w-100 h330 px20"
      style="overflow-y: auto; max-height: 600px; min-height: 400px"
    >
      <span>위도</span>
      <div id="gnssRawfileChartNo1" class="w-100 h300"></div>
      <span>경도</span>
      <div id="gnssRawfileChartNo2" class="w-100 h300"></div>
      <span>고도</span>
      <div id="gnssRawfileChartNo3" class="w-100 h300"></div>
    </div>
  </div>
</template>

<script>
import chartUtil from "../common/chartUtil";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  props: {
    chartData: {
      type: Array,
    },
  },
  data() {
    return {
      data: [[], [], [], []],
      chartList: 4,
    };
  },
  mounted() {
    this.drawChart(this.chartData);
  },
  destroyed() {
    Plotly.purge("gnssRawfileChartNo1");
    Plotly.purge("gnssRawfileChartNo2");
    Plotly.purge("gnssRawfileChartNo3");
  },
  methods: {
    drawChart(chartData) {
      for (let i = 0; i < chartData.length; i++) {
        this.data[0].push(chartData[i][0]);
        this.data[1].push(chartData[i][1]);
        this.data[2].push(chartData[i][2]);
        this.data[3].push(chartData[i][3]);
      }
      this.$nextTick(() => {
        for (let j = 1; j < this.chartList; j++) {
          this.drawTimeLineChart("gnssRawfileChartNo" + j.toString(), {
            x: this.data[0],
            y: this.data[j],
          });
        }
      });
    },
    drawTimeLineChart(id, options, range) {
      let data = [
        {
          x: options.x,
          y: options.y,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
        },
      ];
      let layout = chartUtil.setTimeLayout(id, {
        margin: {
          l: 80,
          r: 30,
          t: 30,
          b: 50,
          pad: 10,
        },
        annotation: options.annotation,
        showlegend: false,
        showxaxiscnt: 10,
        datacnt: 100,
      });
      layout.xaxis.showticklabels = false;
      Plotly.newPlot(id, data, layout, { scrollZoom: true });
    },
  },
};
</script>
<style lang="scss">
#gnssRawfileChartModal {
  max-width: 1200px;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/sensor/GnssRawfileChartModal.vue